module.exports = "/_next/static/images/paper-363f8df918c31ab2aae2a979d07386ae.png";